"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTokenAdminFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "DeregisterSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DisablePullReservesPublicAccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "EnablePullReservesPublicAccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldFallback",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newFallback",
                type: "address",
            },
        ],
        name: "FallbackAddressChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reservesToPull",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "PullError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reserveRecipientAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        name: "PullSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "RegisterError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
        ],
        name: "RegisterSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldReserveRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newReserveRatio",
                type: "uint256",
            },
        ],
        name: "ReserveRatioChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRecipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRecipient",
                type: "address",
            },
        ],
        name: "ReserveRecipientChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        name: "ResignAdminError",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "ResignAdminSuccess",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRewardRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRewardRatio",
                type: "uint256",
            },
        ],
        name: "RewardRatioChanged",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tTokens",
                type: "address[]",
            },
        ],
        name: "acceptTTokenAdmins",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "currentFallbackAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
        ],
        name: "deregisterSingleTTokenToPull",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tTokens",
                type: "address[]",
            },
        ],
        name: "deregisterTTokensToPull",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "enablePullReservesPublicAccess",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
        ],
        name: "getReservesToPull",
        outputs: [
            {
                internalType: "uint256",
                name: "reservesToPull",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getTokensToPull",
        outputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_reserveRatio",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_reserveRecipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_rewardRatio",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
        ],
        name: "isRegisteredTToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastPulledReserve",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pullReserves",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pullReservesPublicAccess",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "_isTEther",
                type: "bool",
            },
        ],
        name: "registerSingleTTokenToPull",
        outputs: [
            {
                internalType: "uint256",
                name: "errorCode",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tTokens",
                type: "address[]",
            },
            {
                internalType: "bool[]",
                name: "_isTEther",
                type: "bool[]",
            },
        ],
        name: "registerTTokensToPull",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRatioBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "reserveRecipient",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tToken",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_newAdmin",
                type: "address",
            },
        ],
        name: "resignSingleTTokenAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_tTokens",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "_newAdmins",
                type: "address[]",
            },
        ],
        name: "resignTTokenAdmins",
        outputs: [
            {
                internalType: "uint256[]",
                name: "errorCodes",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRatioBase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newFallbackAddress",
                type: "address",
            },
        ],
        name: "setFallbackAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reserveRatio",
                type: "uint256",
            },
        ],
        name: "setReserveRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_reserveRecipient",
                type: "address",
            },
        ],
        name: "setReserveRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_rewardRatio",
                type: "uint256",
            },
        ],
        name: "setRewardRatio",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_pullAmount",
                type: "uint256",
            },
        ],
        name: "splitPullAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "reserveAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "rewardAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tEther",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdrawETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class TTokenAdminFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TTokenAdminFactory = TTokenAdminFactory;
TTokenAdminFactory.bytecode = _bytecode;
TTokenAdminFactory.abi = _abi;
//# sourceMappingURL=TTokenAdminFactory.js.map